<script setup>
import SelectCourse from "@/components/Dashboard/Utilities/Config/SelectCourse.vue";
import UtilityDropdownsContainer from "@/components/Dashboard/Utilities/Config/UtilityDropdownsContainer.vue";
import UtilityInputsContainer from "@/components/Dashboard/Utilities/Config/UtilityInputsContainer.vue";
import LoadingSpinner from "@/components/Dashboard/LoadingSpinner.vue";
import useConfigView from "@/scripts/Utilities/ConfigView.js";
import ConfirmationModal from "@/components/ConfirmationModal.vue";

const {
  showConfirmModal,
  course,
  config,
  updateFieldObject,
  updateConfig,
  handleSaveClick,
  isUpdateObjectEmpty,
  updating,
  loading,
} = useConfigView();
</script>

<template>
  <div class="content-header">
    <div class="container-fluid">
      <div class="row mb-2"></div>
    </div>
  </div>

  <ConfirmationModal
    v-if="course && course.has_app_device === true"
    :show="showConfirmModal"
    :title="'Send Config to devices?'"
    :message="'Would you like to send the config to all devices?'"
    :confirmColor="'success'"
    :cancelText="'Send to course'"
    confirmText="Send to devices and course"
    @confirm="updateConfig(true)"
    @cancel="updateConfig(false)"
    @close="showConfirmModal = false"
  />

  <ConfirmationModal
    v-else
    :show="showConfirmModal"
    :title="'Send Config to Course?'"
    :message="'Would you like to send the config to the course?'"
    :confirmColor="'success'"
    :cancelText="'Cancel'"
    confirmText="Send to course"
    @confirm="updateConfig(false)"
    @cancel="showConfirmModal = false"
    @close="showConfirmModal = false"
  />

  <section class="content">
    <div class="container-fluid">
      <div class="card">
        <div class="card-body">
          <SelectCourse v-model="course" />
          <LoadingSpinner v-if="loading" />
          <div
            v-if="!loading && course && Object.keys(config).length > 0"
            class="row"
          >
            <UtilityDropdownsContainer :updateFieldObject="updateFieldObject" />
            <UtilityInputsContainer :updateFieldObject="updateFieldObject" />
            <div class="col-sm-12">
              <button
                id="save_config"
                @click="handleSaveClick"
                type="button"
                class="btn btn-success btn-sm float-right"
                :disabled="!course || isUpdateObjectEmpty"
              >
                <font-awesome-icon
                  v-show="updating"
                  :icon="['fas', 'spinner']"
                  spin
                />
                <span v-show="!updating">SAVE</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
